const selectDemo = document.querySelector('.wpcf7-form-control-wrap.demo select')
const mensaje = document.querySelector('.wpcf7-form-control-wrap.your-message textarea')
if(selectDemo){
selectDemo.addEventListener('change', ()=>{
    // console.log(selectDemo.value);
    // console.log();
    if(getMeta('og:locale') == 'en_US'){
       if(selectDemo.value == 'ALTO Track' ){
        mensaje.value = 'Hi ALTO, I’m interested in seeing a demo of ALTO Track.  Please reach out to me to schedule a time for us to talk!'
       }
       if(selectDemo.value == 'ALTO Alliance' ){
        mensaje.value = 'Hi ALTO, I’m interested in seeing a demo of ALTO Alliance.  Please reach out to me to schedule a time for us to talk!'
       }
       if(selectDemo.value == 'Inmune ALTO' ){
        mensaje.value = 'Hi ALTO, I’m interested in seeing a demo of Inmune ALTO.  Please reach out to me to schedule a time for us to talk!'
       }
       if(selectDemo.value == 'ALTO BGC' ){
        mensaje.value = 'Hi ALTO, I’m interested in seeing a demo of ALTO BGC.  Please reach out to me to schedule a time for us to talk!'
       }
    } else {
      if(selectDemo.value == 'ALTO Track' ){
        mensaje.value = 'Tengo interés en tener una demo de ALTO Track. Agradeceré me pueda contactar para agendar reunión.'
        
       }
       if(selectDemo.value == 'ALTO Alliance' ){
        mensaje.value = 'Tengo interés en tener una demo de ALTO Alliance. Agradeceré me pueda contactar para agendar reunión.'
       }
       if(selectDemo.value == 'Inmune ALTO' ){
        mensaje.value = 'Tengo interés en tener una demo de Inmune ALTO. Agradeceré me pueda contactar para agendar reunión.'
       }
       if(selectDemo.value == 'ALTO BGC' ){
        mensaje.value = 'Tengo interés en tener una demo de ALTO BGC. Agradeceré me pueda contactar para agendar reunión.'
       }
    }
    
})
}

function getMeta(metaName) {
    const metas = document.getElementsByTagName('meta');
  
    for (let i = 0; i < metas.length; i++) {
      if (metas[i].getAttribute('name') === metaName || metas[i].getAttribute('property') === metaName) {
        return metas[i].getAttribute('content');
      }
    }
  
    return '';
  }
  
  